import React from "react";
import { Button } from "../../form/button";
import { Modal } from "../modal";
import { Countdown, StyledButtons, StyledContent } from "./kioskOverlay.styles";
import { KioskOverlayProps } from "./kioskOverlay.types";

export const KioskOverlay = ({ heading, description, buttons, secondsRemaining }: KioskOverlayProps) => {
  return (
    <Modal>
      <StyledContent>
        <h2>{heading}</h2>
        <p>{description}</p>
      </StyledContent>
      <StyledButtons>
        {buttons && buttons.map((button, index) => (
          <Button key={index} onClick={button.onClick} label={button.label} color={index === 0 ? "pink" : "blue"} expand />
        ))}
      </StyledButtons>
      {secondsRemaining && <Countdown>{secondsRemaining} {secondsRemaining === 1 ? "second" : "seconds"} remaining.</Countdown>}
    </Modal>
  );
}